import {IBackendCaller} from "./backendCaller";

export interface IVillageService {
  getVillageData: () => Promise<any>;
}

export class VillageService implements IVillageService {
  backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  getVillageData = async () => {
    return await this.backendCaller.callApi("GET", "/api/villages");
  };
}
